//CreateExam.jsx
import React, { useState, useEffect } from "react";
import "./createExam.css"
import { Examview } from "./examview";
import { adminCreateExam, adminListExam } from "../../../../services/adminService";
import axiosService from "../../../../helpers/axios";

function CreateExam(){

    const [creatingExam, setcreatingExam] = useState(false)

    const [exam, setExam] = useState({
        "title": "",
        "genre": "",
        "file": "",
        "image": "",
    })

    const [BeatList, setBeatList] = useState()

    const [notification, setNotification] = useState("")

    function Notificate(message) {
        setNotification(message);
        setTimeout(() => {
        setNotification("");
        }, 2500);
    }

/*     function handleSuccessfullCreate(accessCode) {

        navigator.clipboard.writeText(accessCode);

        setsuccess("Exam created successfully!");

        setTimeout(() => {

            setsuccess("");

        }, 3000);

    } */
    

    useEffect(() => {
        axiosService.get("/creator/Beat/")
            .then((res) => {
                setBeatList(res.data);
            })
        },
        [creatingExam]
    );

    const createBeat = (e) => {

        e.preventDefault()
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        axiosService.post("/creator/Beat/", exam, config )
            .then(res => {
                res.status === 200 && Notificate("Beats Created successfully");
                setExam({
                    "title": "",
                    "genre": "",
                    "file": null,
                    "image": "",
                })
                toggle();
            }).catch((error) => console.error(error))
    }

    function handleChange(e){
        const {name, value, type, files} = e.target
        setExam(prev => ({
            ...prev,
            [name] : type === "file" ? files[0] : value
        }
        ))
    }

    function toggle(){
        setcreatingExam(prevstate => !prevstate)
    }

    
    return(
        <div className="exam--creation">
        
            <div className="list--of-exam">
                <div className="create--exam-btn">
                    <button onClick={toggle}>Add your Beat<i class="fa-solid fa-plus"></i></button>
                </div>
                <ul className="exam--list">
                    {BeatList && BeatList.map(exam => (
                        <Examview exam={exam} />
                        
                    ))}
                </ul>
            </div>
            
            <div className={`blury ${creatingExam && "shown"}`}>
                {notification && <div className="notification"><p>{notification} </p><div onClick={()=>setNotification("")} className="closebtn"><i className="fa-solid fa-xmark"></i></div></div>}
                <div className="exit--button" onClick={toggle}><i className="fa-solid fa-xmark"></i></div>
                <div className="form--container">
                    <form className="forms" onSubmit={createBeat}>
                        <div className="form--title">Post Your Beats</div>
                        <label>Title :
                            <input
                                type="text"
                                name="title"
                                value={exam.title}
                                onChange={(event) => handleChange(event)}
                                className="input--box"

                            />
                        </label>
                        <label htmlFor="genre" >Select a music genre</label>
                            <select id="genre" name="genre" className="input--box" value={exam.genre} onChange={(event) => handleChange(event)}>
                                <option  value="INSTRUMENTAL">INSTRUMENTAL</option>
                                <option value="TRAP">TRAP</option>
                                <option value="AFROTRAP">AFROTRAP</option>
                                <option value="AFROBEATS">AFROBEATS</option>
                                <option value="FREESTYLE">FREESTYLE</option>
                                <option value="IMPRO">IMPRO</option>
                            </select>

                        <label>Music file 
                            <input
                                type="file"
                                name="file"
                                onChange={(event)=>handleChange(event)}
                                className="input--box"
                                accept="audio/*"
                                
                            />
                        </label>

                        <label>Image 
                            <input
                                type="file"
                                name="image"
                                onChange={(event)=>handleChange(event)}
                                className="input--box"
                                accept="image/*"

                            />
                        </label>
                        
                        <button className="submit--button">
                            Post Beat
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                        </button>
                    
                    
                    </form>
                </div>
            </div>
          

        
        </div>
    )
}

export default CreateExam